import axios from 'axios';
import { apiUrl } from '../../config/constants';
import { tokenManager } from '../token-manager';




export const axiosInstance = axios.create({
    withCredentials: false,
    baseURL: apiUrl,
});


axiosInstance.interceptors.request.use(
    (config) => {
        //this is for token
        const token = tokenManager.getToken();
        if (token && config.headers) {
            config.headers['Authorization'] = 'Bearer '+token;
            //config.headers['Content-Type'] = "multipart/form-data";
            // config.headers['Access-Control-Allow-Origin'] =  "*";
            // config.headers['Access-Control-Allow-Credentials'] = "true";
            // config.headers['Access-Control-Allow-Methods'] = "GET,HEAD,OPTIONS,POST,PUT";
            // config.headers['Access-Control-Allow-Headers'] = "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers";
            //config.headers['xc-auth'] = token;
            //config.headers['xc-token'] = token;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Intentionally avoid logging sensitive error details in production

    // ❗ Case 1: No response (network/CORS)
    if (!error.response) {
      console.error("Network or CORS Error");
      setTimeout(() => {
        window.location.href = "/";
      }, 100);
      return Promise.reject(error);
    }

    const status = error.response.status;

    //  Case 2: 401 / 403 - Unauthorized
    if (status === 401 || status === 403) {
      console.warn("401/403 detected. Redirecting to login...");
      // ALWAYS use setTimeout to avoid React state conflicts
      setTimeout(() => {
        window.location.href = "/";
      }, 100);

      return Promise.resolve(); // stops further processing
    }

    // Other errors → forward
    return Promise.reject(error);
  }
);


export const photoaxiosInstance = axios.create({
    withCredentials: false,
    baseURL: apiUrl,
});


photoaxiosInstance.interceptors.request.use(
    (config) => {
        //this is for token
        const token = tokenManager.getToken();
        if (token && config.headers) {
            config.headers['Authorization'] = 'Bearer '+token;
            config.headers['Content-Type'] = "multipart/form-data"
            // config.headers['Access-Control-Allow-Origin'] =  "*";
            // config.headers['Access-Control-Allow-Credentials'] = "true";
            // config.headers['Access-Control-Allow-Methods'] = "GET,HEAD,OPTIONS,POST,PUT";
            // config.headers['Access-Control-Allow-Headers'] = "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers";
            //config.headers['xc-auth'] = token;
            //config.headers['xc-token'] = token;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
}
);

photoaxiosInstance.interceptors.response.use(
    (response) => {
        // Intentionally avoid logging sensitive responses in production
        return response;
    },
    async (error) => {
        if (error.response.status === 401 || error.response.status === 403) {
            //window.location.href = "/";
           }else{
            // Intentionally avoid logging sensitive error details in production
             return Promise.reject(error);
        }
    }

);
